export default {
    //search-company
    people: "潜在客户",
    clearAll: "清除所有",
    searchProspects: "搜索...",
  
    //actions
    isFoundIn: "在 ",
    isNotFoundWithinAnyLists: "未在任何列表中找到",
    l: " 列表",
    remove: "移除",
    saveToLists: "保存到列表",
    DeleteFailed: "删除失败",
  
    //delete dialog
    areYouSureYouWantToDeleteThisRecord: "您确定要删除此记录吗？",
    proceedingWithDeletionWillResultInPermanentRemovalOfTheList:
      "进行删除将导致该列表永久移除。",
    byCancelingYouEnsureThatNoListsWillBeRemoved:
      "通过取消，您可以确保不会移除任何列表。",
  
    //export dialog
    holdOnWereGeneratingYourExport: "请稍候，我们正在生成您的导出文件。",
    UseThisButtonOnlyIfYouWishToCancelYourAction:
      "仅在您希望取消操作时使用此按钮。",
  
    //save search pop
    saveSearch: "保存搜索",
    newSaveSearch: "新保存搜索",
    UpdateSavedSearch: "更新已保存搜索",
    enterNewSearchName: "输入新搜索名称",
    visibility: "可见性",
    manageWhoCanSeeYourSavedSearch: "管理谁可以查看您的已保存搜索",
    private: "私有",
    onlyYouCanSeeYourSavedSearch: "只有您可以查看您的已保存搜索",
    everyoneCanSeeYourSavedSearch: "每个人都可以查看您的已保存搜索",
    pinSavedSearch: "固定已保存搜索",
    findSavedSearch: "查找已保存的搜索",
    enterSavedSearchName: "输入已保存搜索名称",
  
    duplicate: "重复",
    update: "更新",
    enterATitleForYourCard: "为您的卡片输入标题",
    enterYourCardNumber: "输入您的卡号",
    digit: "3位数",
    provideYourCompleteAddress: "提供您的完整地址",
    selectYourCountry: "选择您的国家",
  
    //add credits pop
    ClickTheButtonBelowToAddMoreCredits: "点击下面的按钮以添加更多信用点数！",
    PleaseEnterTheAmountYouLikeToTopUpToYourCredit: "请输入您希望充值的金额",
  
    //companyLink\contactBtn\functionBtn
    more: "更多",
    verified: "已验证",
    GetEmailSuccessfully: "成功获取电子邮件",
    CopySuccessfully: "成功复制",
    recorded: "已记录",
    implement: "实施",
    sequence: "工作流程",
    of: " 总条数：",
    toAssistYouEffectivelyWeRequireFurtherDetailsAbout:
      "为了有效协助您，我们需要进一步了解您的搜索偏好。请利用左侧面板中的筛选选项来指定您所需的标准，以便我们能够精炼搜索结果，并为您提供符合要求的目标。",
  
    //filter
    all: "所有",
    my: "我的",
    team: "团队",
    lists: "列表",
    employees: "员工",
    technologies: "技术",
    socialmedia: "社交媒体",
    enterSocialMedia: "输入社交媒体",
    noResultsFound: "未找到结果",
    searchCompanies: "搜索公司",
    filters: "筛选器",
    enterCompanies: "输入公司名称",
    accountHqLocation: "帐户总部位置",
    CityStateCountryZIP: "城市/州/国家/邮政编码",
    enterLocations: "输入地点",
    revenue: "收入",
    chooseARangeOfRevenue: "选择收入范围",
    ofRevenueIsUnknown: "收入未知",
    technology: "技术",
    category: "类别",
    categories: "类别",
    enterCategories: "输入类别",
    enterTechnologies: "输入技术",
    enterIndustries: "输入行业",
    employee: "员工",
    predefinedRange: "预定义范围",
    ofEmployeesIsUnknown: "员工数量未知",
    enterNames: "输入姓名",
    jobTitle: "职位名称",
    searchForAJobTitle: "搜索职位名称",
    founded: "成立时间",
    chooseARangeOfFoundedTime: "选择成立时间范围",
    from: "从",
    to: "到",
    specialties: "专业领域",
    enterSpecialties: "输入专业领域",
    location: "地点",
    excludedLocationsLabel: '位置 [排除]',
    location_exclude: "[排除]",
    total: "总计",
    department: "部门",
    EnterDepartments: "输入部门",
    JobTitle: "职位名称",
    EnterJobTitles: "输入职位名称",
    ManagementLevel: "管理层级别",
    EnterManagementLevels: "输入管理层级别",
    AccountHQ: "帐户总部",
    ContactHQ: "联系总部",
    departmentFunction: "部门功能",
    EnterJobFunctions: "输入职务功能",
    enterNamesAndPressTheEnterKey: "输入姓名并按Enter键...",
    EnterJobTitlesAndPressTheEnterLKey: "输入职位，然后按Enter键...",
    contactDetails: "联系方式",
    filterMustContain: "必须包含",
    filterWorkEmail: "工作邮箱",
    filterPersonalEmail: "个人邮箱",
    filterPhone: "电话号码",
    filterHasEmail: "有邮箱",
    filterHasPhone: "有电话号码",
    filterExcludeWithoutContact: "排除没有联系方式的联系人",
    pleaseSelectRange: "请选择范围",
    exclude_locations: "排除位置",
    filterExclude: "排除",
  
    //table
    selectAllCompanies: "选择所有公司",
    selected: "已选择",
    export: "导出",
    industry: "行业",
    keywords: "关键字",
    companyLocation: "公司位置",
    action: "操作",
    contact: "联系人",
    Title: "职称",
    clearSelection: "清除选择",
    selectNumberOfCompanies: "选择公司数量",
    maxCompanies: "最多公司数量",
    youCanOnlySelectAMaximumOf25Companies: "您最多只能选择25家公司。",
    UpgradeYourPlanNow: "立即升级您的计划！",
    viewPlans: "查看计划",
    applySelection: "应用选择",
    selectNumberOfProspects: "选择潜在客户数量",
    maxProspects: "最多潜在客户数量",
    maxProspectsPerCompany: "每家公司最多潜在客户数",
    youCanOnlySelectAMaximumOf25Prospects: "您最多只能选择25个潜在客户。",
    PleaseSelectTheDataToBeExported: "请选择要导出的数据",
    overview: "概览",
    genericContacts: "通用联系人",
    size: "规模",
    contactLocation: "联系人位置",
    pleaseSelectItems: "请选择操作项",
    specialties: "专长",


    // 新UI
    prospectsSearch: "潜在客户搜索",
    companiesSearch: "公司搜索",
    savedSearches: "保存的搜索",
    savedLists: "已保存列表",

    // saved list and saved searches
    sortAndFilter: "排序和筛选",
    sortBy: "排序方式",
    filterAll: '所有',
    filterPrivate: '私人的',
    filterTeam: '团队',
    searchSavedLists: "搜索已保存的列表",
    savedSearchName: "已保存的搜索名称",
    noFilteringOptionsAvailable: "没有可用的筛选选项",
    manageWhoCanSeeThisSearch: "管理谁可以查看此搜索",
    noSavedSearchesMatchYourQuery: "没有保存的搜索与您的查询匹配。尝试使用不同的关键字或检查拼写。",
    onlyU: "只有您",
    anyoneOnTheTeam: "团队中的任何人",
    createNewList: "创建新列表",
    groupTeam: "团队",
    groupPersonal: "个人",
    manageWhoCanViewThisList: "管理谁可以查看此列表",
    enterAListName: "输入一个列表名称",
    savedList: "已保存列表",
    listName: "列表名称",
    saveContactsTo: "将联系人保存到",
    contactEmails: "联系电子邮件",
    contactPhones: '联系电话',
    unlockContactDetails: "解锁联系人详细信息",
    getContactInfo: '获取联系信息',
    contactDetailsAreOnTheWay: "联系方式正在路上",
    noDataAvailable: '无可用数据',
    accessEmails: "兑换邮件",
    accessPhoneNumber: "兑换电话",
    accessPhoneNumbersAndEmails: "兑换邮件和电话",
    redemptionComplete: "兑换完成！",
    bulkRedeemProcessing: "批量兑换处理中...",
    notifyMeWhenCompleted: "完成后通知我",
    expectedTime: "预计时间：",
    redeemSeconds: "{count}秒",
    redeemLoading: "加载中...",
    estimatedCharge: "预计费用：{count}信用点",
    estimatedCost: "估计花费: {count} 信用点数",
    finalChargeBasedOnRequest: "最终费用可能因请求的成功完成而有所不同",
    showLess: "显示较少",
    exportLeadsToCSV: "导出CSV",
    exportComplete: "导出完成！",
    exporting: "导出中。。。",
    pleaseSelectTheFieldsThatNeedToBeExported: "请选择需要导出的字段",
    exportLeads: "您即将导出{count}潜在客户。这可能需要一些时间，具体取决于您选择的大小。| 您即将导出{count}个潜在客户。这可能需要一些时间，具体取决于您选择的数量。",
    dataFieldsToInclude: "要包含的数据字段",
    savedListRecords: '{count}条记录',
    deleteList: "删除列表",
    actionCannotBeUndone: "您确定要删除此列表吗？此操作无法撤消。",
    selectedContactsNumber: "{count} 位所选的联系人",
    btnSave: "已存列表",
    btnUnsave: "取消保存",
    specialties: '专长',
    moreSpecialty: "更多{count}项专长",
    selectCompanyNumber: "根据您当前的计划选择{count}家公司。",
    selectPeopleNumber: "使用您当前的计划向上选择{count}个潜在客户。",
    upgradeNowToAccessMore: "立即升级以访问更多内容！",
    selectAll: "全部",
    selectThisPage: '当前页',
    selectCustomize: '自定义',
    pleaseSelectTheFilteringType: "请选择筛选类型",
    theQuantityCannotBeZero: '数量不能为0',
    filterSearch: "筛选搜索",
    view: "查看",
    deleteSavedSearch: "删除已保存的搜索",
    deleteThisSavedSearch: "您确定要删除此已保存的搜索吗？此操作无法撤消。",
    createASequenceToStartAutomatingYourOutreach: "创建一个序列来开始自动化您的外展，并在准备就绪时在此处添加项目。",
    unsaveThemFromHere: "如果选定的潜在客户已被保存，您可以在此处取消保存。",
    createAListToSaveAndOrganizeProspects: "创建一个列表来保存和组织您的潜在客户",
    savedFilters: "已保存的筛选",
    viewResults: "查看搜索结果",


    // search empty
    resultNoResultsFound: "未找到结果",
    noContactsThatMatchYourSearch: "您的搜索或筛选器没有匹配项。尝试更改过滤器或使用不同的关键字。",
    requestTimedOut: "请求超时",
    theServerIsCurrentlyBusy: "服务器当前正忙，我们无法加载结果。请尝试刷新页面。",
    btnRefresh: "刷新",

    // tooltip
    tooltipRedeemEmail: "兑换电子邮件",
    tooltipRedeemPhone: "兑换电话号码",
    tooltipRedeemEmailAndPhone: "兑换全部",
    tooltipSearchPeople: "从选定的公司中寻找潜在客户",
    tooltipFilter: "筛选",
    tooltipSequence: "工作流程",
    tooltipSave: "保存至列表",
    textFindPeople: "寻找人员",

    // recent mode
    recentMode: "最近模式",
    tryRealTimeAgain: "再次尝试实时模式",
    realTimeResultsAreTemporarilyPaused: '由于 API 限制，实时结果已暂时暂停',

    // company-detail
    companies: "公司",

    // recent search
    popularUseCases: "热门用例",
    skipTheGuesswork: "跳过猜测，从热门筛选组合开始。",
    labelRecentSearches: "最近的搜索",
    labelRecentSavedFilters: "最近保存的筛选条件",
    useThisFilterSetup: "使用这个筛选配置",
    startByApplyingFilters: "从左侧面板开始应用筛选器，以发现相关的联系人和公司。",


    //
    k: '千',

  filterAdvertisementStartDateSubTitle: "广告开始日期范围",
  filterAdvertisementEndDateSubTitle: "广告结束日期范围",
  filterAdvertisementSearchTermsSubTitle: "广告搜索词",
  filterAdvertisementExcludeTargetLocation: "排除目标地点",
  active_filters_count: "1 个筛选条件 | {count} 个筛选条件",
  company_list: "公司列表",
  filter_presets: "筛选预设",
  my_list: "我的列表",
  company_profile: "公司简介",
  people_workforce: "人员与劳动力",
  technology_presence: "技术与覆盖范围",
  saved_searches_count: "{count} 个已保存",
  filterJobExcludeLocation: "排除职位地点",

  enter_keywords: "输入关键词",
  filter_keywords_description_search_title: "在描述中搜索",
  filter_keywords_description_search_tooltip: "在公司描述中搜索关键词。",
  filter_places_description_search_title: "排除特定地点",
  filter_places_description_search_tooltip: "从搜索结果中排除特定地点。",
  enter_places: "输入地点",
  enterAdvertisementSearchTerms: "输入搜索词，然后按Enter键...",
  people_list: "人员列表",
  clear: "清除",
  places: "地点",

  expand_filters: "打开筛选",
  collapse_filters: "关闭筛选",
};
